import { useEffect, useState } from 'react'
import {
  Checkbox,
  FormControl,
  FormLabel,
  MenuItem,
  Select
} from '@material-ui/core'
import toastError from '../../errors/toastError'
import api from '../../services/api'
import { useStyles } from './style'

const ALL_VALUE = 'all'

export function ConnectionsFilter({ onFiltered, label = 'Conexão' }) {
  const classes = useStyles()
  const [connections, setConnections] = useState([])
  const [selecteds, setSelecteds] = useState([])

  useEffect(() => {
    const loadConnections = async () => {
      try {
        const { data } = await api.get('/whatsapp/')
        const connectionList = data.map(c => ({
          id: c.id,
          name: c.name,
          queues: c.queues || []
        }))
        setConnections(connectionList)
      } catch (err) {
        toastError(err)
      }
    }
    loadConnections()
  }, [])

  useEffect(() => {
    if (connections.length > 0 && selecteds.length === 0) {
      setSelecteds(connections)
      onFiltered(connections, { connections, isAllSelected: true })
    }
  }, [connections])

  const isAllSelected =
    connections.length > 0 && selecteds.length === connections.length

  const selectedIds = selecteds.map(connection => connection.id)

  const handleChange = event => {
    const value = event.target.value
    const clickedAll = value.includes(ALL_VALUE)

    let newSelection
    if (clickedAll) {
      newSelection = isAllSelected ? [] : connections
    } else {
      newSelection = connections.filter(connection =>
        value.includes(connection.id)
      )
    }

    setSelecteds(newSelection)
    const allSelected = newSelection.length === connections.length
    onFiltered(newSelection, { connections, isAllSelected: allSelected })
  }

  const selectValue = isAllSelected
    ? [ALL_VALUE, ...selectedIds]
    : selectedIds

  const renderValue = () => {
    if (selecteds.length === 0) return 'Selecione'
    if (isAllSelected) return 'TODOS'
    const text = selecteds.map(option => option.name).join(', ')
    return (
      <span className={classes.selectedText} title={text}>
        {text}
      </span>
    )
  }

  return (
    <FormControl fullWidth className={classes.formControl}>
      <FormLabel>{label}</FormLabel>
      <Select
        multiple
        displayEmpty
        variant="outlined"
        value={selectValue}
        onChange={handleChange}
        renderValue={renderValue}
        MenuProps={{
          anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
          transformOrigin: { vertical: 'top', horizontal: 'left' },
          getContentAnchorEl: null
        }}
      >
        <MenuItem value={ALL_VALUE}>
          <Checkbox
            className={classes.checkbox}
            checked={isAllSelected}
            size="small"
            color="primary"
          />
          TODOS
        </MenuItem>
        {connections.map(connection => (
          <MenuItem key={connection.id} value={connection.id}>
            <Checkbox
              className={classes.checkbox}
              checked={selectedIds.includes(connection.id)}
              size="small"
              color="primary"
            />
            {connection.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
